/**
 * handleEdit.js
 *
 * Copyright (c) apploft. GmbH
 */

import {http, URL, APIDefinition} from 'apploft-cloud-client';
import {fetchingItem} from '../ContentStateSymbol';
import {failedItemRequest, itemReceived} from '../ContentEventSymbol';
import {stringMatching} from 'apploft-cloud-forms';
// @ts-ignore
import strings from '../../../assets/strings.json';

export default function handleEdit({section, api, dispatch, item: {objectId}}) {
  const paths = APIDefinition.pathsMatching(section, api);
  const url = URL.createGetUrl({api, paths, objectId});

  console.assert(typeof url === 'string');

  const authorization = APIDefinition.keyAdminAuth(api);
  const controller = new AbortController();
  const {signal} = controller;
  const {get} = http;

  get({url, authorization, signal})
    .then(item => {
      if (typeof item !== 'object') {
        throw new Error('not an Object');
      }

      dispatch({event: itemReceived, payload: {item, section, api}});
    })
    .catch(error => {
      if (error instanceof DOMException) {
        console.assert(
          error.message === 'The user aborted a request.',
          `unexpected error: ${error.message}`,
        );

        return;
      }

      dispatch({
        event: failedItemRequest,
        payload: {error, section, api},
      });
    });

  return {
    state: fetchingItem,
    data: `${stringMatching(strings, 'Fetching')} ${objectId}...`,
    controller,
  };
}
